import {Pages} from 'shared/config/model/pages';

import React from 'react';
import {i18n} from '@lingui/core';
import {t} from '@lingui/core/macro';

import {promoCodeAPI, tariffAPI} from 'entities/tariff';
import {getPollingInterval} from 'shared/api/pollingHelper';
import useListParams from 'shared/lib/hooks/useListParams';

import {PROMO_CODE_FILTER_KEYS} from '../../lib/adminFilterKeys';
import AdminListScreen from '../AdminList/AdminListScreen/AdminListScreen';
import AdminCreateButton from '../AdminList/AdminCreateButton';
import PromoCodesRow from './PromoCodesRow';
import PromoCodesModal from './PromoCodesModal';
import PromoCodesFiltersForm from './PromoCodesFiltersForm/PromoCodesFiltersForm';

const PromoCodes: React.FC = () => {
    const params = useListParams({filterKeys: PROMO_CODE_FILTER_KEYS});
    const query = promoCodeAPI.useGetPromoCodesQuery(params.args, {pollingInterval: getPollingInterval()});
    const {data: tariffs} = tariffAPI.useGetTariffsQuery({field: 'price', direction: 'asc'});

    return (
        <AdminListScreen
            title={t`Промокоды`}
            heading={i18n._(Pages.ADMIN_PROMO_CODES)}
            createButton={<AdminCreateButton label={t`Добавить промокод`} Modal={PromoCodesModal}/>}
            columns={[
                {label: 'ID', sort: 'id'},
                {label: 'Значение', sort: 'value'},
                {label: 'Тариф', sort: 'tariff.name'},
                {label: 'Период, дней', sort: 'period'},
                {label: 'Действует до', sort: 'expire_at'},
                {label: 'Активаций', sort: 'activations'},
                {label: 'Статус', sort: 'published'},
                {label: ''},
            ]}
            params={params}
            query={query}
            rowFactory={item => <PromoCodesRow key={item.id} item={item} tariffs={tariffs}/>}
            FiltersForm={PromoCodesFiltersForm}
        />
    );
};

export default React.memo(PromoCodes);
